<template>
  <div>
    <v-layout row>
      <v-flex xs6>
        <v-btn @click="back" flat>
          <v-icon>keyboard_arrow_left</v-icon>
          back
        </v-btn>
      </v-flex>
      <v-flex xs6 style="text-align:right;">
        <v-btn @click="d_edit = true" flat>
          <v-icon>settings</v-icon>
          Settings
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container>
      <h1><v-icon style="padding-bottom:5px;">storage</v-icon> {{ b_name }}</h1>
      <v-layout row wrap style="margin-top:30px;">
        <v-flex xs12 sm6>
          <v-treeview :items="b_containers">
            <template v-slot:prepend="{ item }">
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </template>
            <template slot="label" slot-scope="{ item }">
              <!-- Containers -->
              <span v-if="item.action === undefined" @click="openContainer(item)" style="cursor:pointer;">{{ item.name }} <span style="color:grey;">ID: {{ item.id }}</span></span>
              <!-- Columns -->
              <span v-if="item.action === 'column'" @click="openColumn(item)" style="cursor:pointer;">{{ item.name }} <span style="color:grey;">ID: {{ item.id }}</span></span>
              <!-- New container -->
              <span v-if="item.action === 'add_container'" @click="d_add_container = true;f_new_container_bucket=item.parent_id" style="cursor:pointer;">{{ item.name }}</span>
              <!-- New column -->
              <span v-if="item.action === 'add_column'" @click="d_add_column = true;f_new_column_container=item.parent_id" style="cursor:pointer;">{{ item.name }}</span>
            </template>
          </v-treeview>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog for editing buckets -->
    <v-dialog
      v-model="d_edit"
      width="500"
    >
      <v-card>
        <v-form @submit="saveEdit">
          <v-card-title
            class="headline"
            primary-title
          >
            Bucket settings
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="d_delete = true"
              type="button"
            >
              Delete
            </v-btn>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a bucket -->
    <v-dialog
      v-model="d_delete"
      width="500"
    >
      <v-card>
        <v-form>
          <v-card-title
            class="headline"
            primary-title
          >
            Delete bucket
          </v-card-title>

          <v-card-text>
            <p>You are about to delete this bucket (with all the data like datasets, etc.). Do you really want to continue? This process cannot be undone.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              flat
              @click="d_delete = false"
              type="button"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red"
              flat
              @click="deleteBucket"
              type="button"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a container -->
    <v-dialog
      v-model="d_delete_container"
      width="500"
    >
      <v-card>
        <v-form>
          <v-card-title
            class="headline"
            primary-title
          >
            Delete container
          </v-card-title>

          <v-card-text>
            <p>You are about to delete this container (with all the data inside). Do you really want to continue? This process cannot be undone.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              flat
              @click="d_delete_container = false"
              type="button"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red"
              flat
              @click="deleteContainer"
              type="button"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a column -->
    <v-dialog
      v-model="d_delete_column"
      width="500"
    >
      <v-card>
        <v-form>
          <v-card-title
            class="headline"
            primary-title
          >
            Delete column
          </v-card-title>

          <v-card-text>
            <p>You are about to delete this column (with all the data associated with this column). Do you really want to continue? This process cannot be undone.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              flat
              @click="d_delete_column = false"
              type="button"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red"
              flat
              @click="deleteColumn"
              type="button"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding columns -->
    <v-dialog
      v-model="d_add_column"
      width="500"
    >
      <v-card>
        <v-form @submit="saveAddColumn">
          <v-card-title
            class="headline"
            primary-title
          >
            Add column for ID {{ f_new_column_container }}
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_new_column_name" ref="new_column_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding containers -->
    <v-dialog
      v-model="d_add_container"
      width="500"
    >
      <v-card>
        <v-form @submit="saveAddContainer">
          <v-card-title
            class="headline"
            primary-title
          >
            Add container
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_new_container_name" ref="new_container_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for editing containers -->
    <v-dialog
      v-model="d_edit_container"
      width="500"
    >
      <v-card>
        <v-form @submit="saveEditContainer">
          <v-card-title
            class="headline"
            primary-title
          >
            Container properties
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_edit_container_name" ref="edit_container_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="d_delete_container = true"
              type="button"
              :loading="l_edit_save"
            >
              Delete
            </v-btn>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for editing columns -->
    <v-dialog
      v-model="d_edit_column"
      width="500"
    >
      <v-card>
        <v-form @submit="saveEditColumn">
          <v-card-title
            class="headline"
            primary-title
          >
            Column properties
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_edit_column_name" ref="edit_column_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="d_delete_column = true"
              type="button"
              :loading="l_edit_save"
            >
              Delete
            </v-btn>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Buckets } from "../logic/Buckets";
import { Notifications } from "../notification";

import { Containers } from "../logic/Containers";
import { Columns } from "../logic/Columns";

export default {
  name: "BucketDetail",
  data(){
    return {
      //Content
      b_name: "",
      b_containers: [],

      //Form
      f_name: "", //Bucket name

      f_new_column_container: -1,
      f_new_column_name: "",

      f_new_container_name: "",

      f_edit_container_id: -1,
      f_edit_container_name: "",

      f_edit_column_id: -1,
      f_edit_column_name: "",

      //Loading states
      l_edit_save: false,

      //Dialogs
      d_edit: false,
      d_delete: false,
      d_add_column: false,
      d_add_container: false,
      d_edit_container: false,
      d_edit_column: false,
      d_delete_container: false,
      d_delete_column: false
    }
  },
  mounted(){
    var project_id = parseInt(this.$route.params.project_id);
    var bucket_id = parseInt(this.$route.params.id);

    var global_this = this;

    this.loadBucketMeta(project_id, bucket_id).then(function(){
      global_this.f_name = global_this.b_name;

      global_this.loadContainers(bucket_id);
    });
  },
  methods: {
    async loadBucketMeta(project_id, bucket_id){
      var bucket = await Buckets.get(project_id, bucket_id);
      if(bucket.status === 200){
        this.b_name = bucket.body.name;
      } else if (bucket.status === 404) {
        Notifications.show("This bucket does not exist.");
        this.$router.replace("/project/" + project_id);
      } else if (bucket.status === 403) {
        Notifications.show("You are not permitted to view in this project.");
        this.$router.replace("/dashboard");
      }
    },
    async loadContainers(bucket_id){
      var global_this = this;

      var response = await Containers.load(bucket_id);
      if(response.status === 200){
        global_this.b_containers = [];
        var containers = response.body;
        containers.forEach(async function(curr){
          //Load columns per container
          var r_columns = await Columns.load(curr.id);
          var children = [];
          if(r_columns.status === 200){
            r_columns.body.forEach(function(curr_col){
              children.push({
                id: parseInt(curr_col.id),
                action: "column",
                icon: "view_column",
                name: curr_col.name
              })
            });
          }

          //New column component
          children.push({
            id: -1,
            parent_id: parseInt(curr.id),
            icon: "add",
            action: "add_column",
            name: "New column"
          });

          //Push containers for the treeview
          global_this.b_containers.push({
            id: parseInt(curr.id),
            name: curr.name,
            children: children
          });
        });
      }
      //New container component
      global_this.b_containers.push({
        id: -1,
        icon: "add",
        action: "add_container",
        name: "New container"
      });
    },
    back(){
      this.$router.go(-1);
    },
    saveEdit(e){
      e.preventDefault();

      var global_this = this;

      var bucket_id = parseInt(this.$route.params.id);
      this.f_name = this.f_name.trim();

      this.l_edit_save = true;

      Buckets.edit(bucket_id, this.f_name).then(function(response){
        global_this.l_edit_save = false;
        if(response.status === 200) {
          Notifications.show(response.message);
          global_this.d_edit = false;
          global_this.b_name = global_this.f_name;
        } else {
          Notifications.show(response.message);
        }
      });
    },
    deleteBucket(){
      var global_this = this;

      var project_id = parseInt(this.$route.params.project_id);
      var bucket_id = parseInt(this.$route.params.id);
      Buckets.delete(bucket_id).then(function(response){
        if(response.status === 200){
          Notifications.show(response.message);
          global_this.$router.replace("/project/" + project_id);
        } else {
          Notifications.show(response.message);
        }
      });
    },
    async saveAddColumn(e){
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers
      this.l_edit_save = true;

      var response = await Columns.add(this.f_new_column_container, this.f_new_column_name);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.d_add_column = false;
        this.f_new_column_name = "";
        this.l_edit_save = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
      }
    },
    async saveAddContainer(e){
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id);
      this.l_edit_save = true;

      var response = await Containers.add(bucket_id, this.f_new_container_name);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_new_container_name = "";
        this.l_edit_save = false;
        this.d_add_container = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
      }
    },
    openColumn(item){
      this.d_edit_column = true;
      this.f_edit_column_id = item.id;
      this.f_edit_column_name = item.name;
    },
    openContainer(item){
      this.d_edit_container = true;
      this.f_edit_container_id = item.id;
      this.f_edit_container_name = item.name;
    },
    async saveEditContainer(e){
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers
      this.l_edit_save = true;

      var response = await Containers.edit(this.f_edit_container_id, this.f_edit_container_name);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_edit_container_name = "";
        this.l_edit_save = false;
        this.d_edit_container = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
        this.l_edit_save = false;
      }
    },
    async deleteContainer(){
      var container_id = this.f_edit_container_id;
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers

      var result = await Containers.delete(container_id);
      if (result.status === 200) {
        Notifications.show(result.message);
        this.d_delete_container=false;
        this.d_edit_container=false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(result.message);
      }
    },
    async deleteColumn(){
      var column_id = this.f_edit_column_id;
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers

      var result = await Columns.delete(column_id);
      if (result.status === 200) {
        Notifications.show(result.message);
        this.d_delete_column=false;
        this.d_edit_column=false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(result.message);
      }
    },
    async saveEditColumn(e){
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers
      this.l_edit_save = true;

      var response = await Columns.edit(this.f_edit_column_id, this.f_edit_column_name);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_edit_column_name = "";
        this.l_edit_save = false;
        this.d_edit_column = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
        this.l_edit_save = false;
      }
    },
  },
  watch: {
    d_add_column(curr){
      var global_this = this;
      if(curr){
        setTimeout(function(){ global_this.$refs.new_column_name.focus(); }, 200);
      }
    },
    d_add_container(curr){
      var global_this = this;
      if(curr){
        setTimeout(function(){ global_this.$refs.new_container_name.focus(); }, 200);
      }
    }
  }
}
</script>
